import * as React from 'react';

import type { IdentityClient } from '@/api/identity-client';
import { HttpIdentityClient } from '@/api/identity-client.http';

// =============================================================================
// identity-client-context.tsx — Injection de l'IdentityClient (DI seam).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle
// plus tard) sans toucher l'UI. Par défaut (Phase 2, D2a-MUT) : l'impl HTTP réelle ;
// le stub reste injectable via le provider en test. Instance partagée (sans état interne).

const defaultIdentityClient: IdentityClient = new HttpIdentityClient();

const IdentityClientContext =
  React.createContext<IdentityClient>(defaultIdentityClient);

export interface IdentityClientProviderProps {
  client?: IdentityClient | undefined;
  children: React.ReactNode;
}

export function IdentityClientProvider({
  client = defaultIdentityClient,
  children,
}: IdentityClientProviderProps): React.JSX.Element {
  return (
    <IdentityClientContext.Provider value={client}>
      {children}
    </IdentityClientContext.Provider>
  );
}

export function useIdentityClient(): IdentityClient {
  return React.useContext(IdentityClientContext);
}
